import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Employee } from "entitites/employees/model/employee";

export const EduBodyView = ({ employee }: { employee: Employee }) => {
  return (
    <Box width="100%" display="flex" gap={0.25} flexDirection="column">
      <TableContainer>
        <Table size="small" aria-label="table">
          <TableHead>
            <TableRow>
              <TableCell>Позиция</TableCell>
              <TableCell>Даты</TableCell>
              <TableCell>ФИО наставника</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employee.eduInfo.eduStages.map((row, i) => (
              <TableRow
                key={row.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  bgcolor:
                    i % 2 === 0 ? "background.default" : "background.paper",
                }}
              >
                <TableCell component="th" scope="row">
                  {row.position}
                </TableCell>
                <TableCell>
                  {row.dates.map((item) => (
                    <Typography key={item.id}>
                      {item.name}: {item.date}
                    </Typography>
                  ))}
                </TableCell>
                <TableCell>{row.coachFio}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
